/**
 * branding
 */

// Module dependencies
import 'protons';
import 'atoms/button';
import 'atoms/image';

import './logo.svg';
import './icon.svg';

import './logo-bw-solo.png';
import './logo-bw-solo.svg';
import './logo-bw.svg';
import './logo-consultare-de.svg';
import './logo-eu.svg';
import './logo-events-de.svg';
import './logo-events-en.svg';
import './logo-footer-events.svg';
import './logo-footer-keffplus.svg';
import './logo-footer-kompetenz.svg';
import './logo-footer-pure.svg';
import './logo-greentech.svg';
import './logo-keffplus-de.svg';
import './logo-keffplus-en.svg';
import './logo-kompetenz-de.svg';
import './logo-kompetenz-en.svg';
import './logo-kompetenz-es.svg';
import './logo-kompetenz-fr.svg';
import './logo-kompetenz-zh-hans.svg';
import './logo-kongress.svg';
import './logo-pure-de.svg';
import './logo-pure-en.svg';
import './logo-utbw-solo.svg';

// Module styles
import './_branding.scss';

// Module template
import './_branding.twig';

export const name = 'branding';

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
// eslint-disable-next-line no-unused-vars
export function enable($context, settings) {}

export default enable;


// This is automatically added by drupal-behaviors-loader
Drupal.behaviors[name] = {
  attach: enable,
  detach: disable,
};